import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';
import { ClusterType } from 'app/models/loyalty-cluster-type.model';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class LoyaltyClusterTypeService {

  private cache = new Map<string, ClusterType>();
  public baseUrl = '/koncentro-loyalty/cluster/clusterType';
  private cachedFields: Observable<any>;

  constructor(
    private http: HttpClientService
  ) { }

  get(clusterTypeId): Observable <ClusterType> {
    return this.http.getPaged(this.baseUrl + '/' + clusterTypeId );
  }

  /*
  list (
      offset = null,
      limit = null,
      search?: Array<{ key: string, value: string }>,
      globalSearch?: string,
      sort?: string,
      sort_dir?: number
  ): Observable <{data: Array<ClusterType>, metadata: ListMetadata}> {
    let params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + '?' + params.toString());
  }
  */
  getAll() {
    return this.http.getPaged(this.baseUrl);
  }

  update(clusterType: ClusterType): Observable<ClusterType> {
   return this.http.put(this.baseUrl + '/' + clusterType.id, clusterType);
  }

  create(clusterType: ClusterType): Observable<ClusterType> {
    return this.http.post(this.baseUrl + '/', clusterType);
  }

  remove(clusterTypeId): Observable<ClusterType> {
   return this.http.delete(this.baseUrl + '/' + clusterTypeId);
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get('/koncentro-loyalty/schema/ClusterTypeDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-cluster-type.service.ts